// extracted by mini-css-extract-plugin
export default {"PomodoroOptions__modal":"PomodoroOptions_PomodoroOptions__modal__RyFzs","PomodoroOptions__controls":"PomodoroOptions_PomodoroOptions__controls__VVigE"};